import {ApplicationConfig, provideBrowserGlobalErrorListeners} from '@angular/core';
import {provideRouter, withInMemoryScrolling} from '@angular/router';

import {routes} from './app.routes';
import {provideClientHydration, withEventReplay, withNoIncrementalHydration} from '@angular/platform-browser';
import {provideHttpClient, withFetch, withInterceptors} from '@angular/common/http';
import {provideNglConfig} from '@vallift/ngl';
import {provideNgxMask} from 'ngx-mask';
import {provideAngularSvgIcon} from 'angular-svg-icon';
import {authTokenInterceptor} from '@core/interceptors/auth-token.interceptor';
import {authErrorInterceptor} from '@core/interceptors/auth-error.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),

    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled',
      })
    ),

    provideClientHydration(
      withEventReplay(),
      withNoIncrementalHydration()
    ),

    provideHttpClient(
      withFetch(),
      withInterceptors([authTokenInterceptor, authErrorInterceptor])
    ),

    provideAngularSvgIcon(),

    provideNglConfig({
      baseApiUrl: 'http://localhost:3000/api/v1/',
      enableUnsavedChangesWarning: true,
      enableDevTools: true,
    }),

    provideNgxMask(),
  ],
};
